import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Cadenas des encarts et structures premium. Hérite de la couleur du texte.
 *
 * Le SVG remplit son hôte au lieu de figer 24 px : sans ça, un
 * `<vw-lock-icon class="h-4 w-4" />` ne redimensionnait rien et le cadenas
 * débordait de sa pastille. La taille par défaut reste 24 px, comme les autres
 * icônes du projet.
 */
@Component({
  selector: 'vw-lock-icon',
  imports: [],
  host: { class: 'inline-block h-6 w-6' },
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4"
      y="10"
      width="16"
      height="11"
      rx="2"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M8 10V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V10"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle cx="12" cy="15.5" r="1.5" fill="currentColor" />
  </svg>`,
})
export class LockIconComponent {}
